var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent_container"},[_c('div',{staticClass:"agent_top"},[_c('p',[_vm._v("代理流程")])]),_c('div',{staticClass:"agent_bottom_img"},[_c('div',{staticClass:"jiange"}),_c('div',{staticClass:"img_back"})])])
}]

export { render, staticRenderFns }